/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  var Ctor = object.constructor;
  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
    Ctor = Object;
  }
  return new Ctor;
}

module.exports = initCloneObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/initCloneObject.js
 ** module id = 397
 ** module chunks = 0
 **/